@if (isVisible()) {
  <aside class="fixed left-3 right-3 top-3 z-50 rounded-xl border bg-card p-3 shadow-lg">
    <p class="text-sm text-foreground">Une nouvelle version est disponible.</p>
    <div class="mt-2 flex justify-end">
      <button
        type="button"
        class="rounded-lg bg-primary px-3 py-2 text-sm font-medium text-primary-foreground"
        (click)="reload()"
      >
        Mettre à jour
      </button>
    </div>
  </aside>
}
